import { getCurrentInstance, computed } from 'vue';

export default function usePageWindowMeta() {
  const _this: any = getCurrentInstance()?.proxy;
  if (!_this) return;

  const currentPageNotFound = computed(
    (): boolean => _this.$store.getters.getCurrentPageMode === 'notfound'
  );
  const page: any = computed((): any => _this.$store.getters.getPage || {});

  const windowMeta = computed(() => {
    if (currentPageNotFound.value) {
      return { title: 'Page | 404 Page not found' };
    } else {
      return { title: `Page | ${page?.value?.title || _this.translate('pageTitlePlaceholder')}` };
    }
  });

  return {
    windowMeta,
  };
}
